export const RANGE_ALL_TIME = 'allTime';
export const RANGE_LAST_4_WEEKS = 'lastWeeks4';
export const RANGE_LAST_6_MONTHS = 'lastMonths6';
export const RANGE_LAST_12_MONTHS = 'lastMonths12';

export function GetRange(id) {

    const endDate = new Date(8640000000000000); // Max Date
    var startDate = new Date(); // now
    var range = null;
    switch (id) {
        case RANGE_ALL_TIME:
            break;
        case RANGE_LAST_4_WEEKS:
            startDate.setDate(startDate.getDate() - 28);
            range = { start: startDate.getTime(), end: endDate.getTime() };
            break;
        case RANGE_LAST_6_MONTHS:
            startDate.setMonth(startDate.getMonth() - 6);
            range = { start: startDate.getTime(), end: endDate.getTime() };
            break;
        case RANGE_LAST_12_MONTHS:
            startDate.setMonth(startDate.getMonth() - 12);
            range = { start: startDate.getTime(), end: endDate.getTime() };
            break;
        default:
            break;
    }

    // console.log(`GetRange id=${id} range=${JSON.stringify(range)}`);
    // if (null !== startDate) console.log(`GetRange startDate | ${startDate.toString()} | ${startDate.toUTCString()} | ${startDate.getTime()}`);
    // if (null !== endDate)   console.log(`GetRange   endDate | ${endDate.toString()} | ${endDate.toUTCString()} | ${endDate.getTime()}`);

    return range;
}
